import { apiPost } from '@/modules/apiHelper';
import authMixin from '@/mixins/auth';

export default {
  name: 'signupMixin',
  mixins: [authMixin],
  data() {
    return {
      // ui
      btnDisabled: false,
      btnText: 'Sign Up',
      // general info
      userForm: {
        // text inputs
        fname: undefined,
        sname: undefined,
        address: undefined,
        // passwords
        password: undefined,
        confirmPassword: undefined,
        // number
        phone: undefined,
        // email
        email: undefined,
        // selects
        gender: undefined,
        county: undefined,
        country: undefined,
      },
      // user specific info
      profession: undefined,
      availability: [],
      availabilityList: [],
      professionList: [],
      // scope
      isScopeApp: false,
      scopeId: undefined,
      secret: undefined,
      //
      errors: {
        secret: undefined,
        profession: undefined,
        availability: undefined,
      },
    };
  },
  watch: {
    // #region array watchers
    availability(val) {
      // console.log('validating availability');
      if (val.length === 0) {
        this.errors.availability = 'Availability is required';
      } else {
        this.errors.availability = undefined;
      }
    },
  },
  methods: {
    updateForm(formData) {
      this.userForm = Object.assign({}, this.userForm, formData);
    },
    onSubmit() {
      if (!this.canSubmit) {
        console.warn('Cannot submit form... \n check for empty inputs');
        return false;
      }
      // signup!!
      this.btnDisabled = true;
      this.btnText = 'working...';
      apiPost('create', this.formData, 10)
        .catch((err) => {
          console.error('create error', err);
          this.$toasted.global.appError();
        })
        .then((res) => {
          this.btnDisabled = false;
          this.btnText = 'sign up';
          if (!res) return false;

          // eslint-disable-next-line prefer-destructuring
          const data = res.data;
          if (data.error) {
            console.error(data.message);
            this.$toasted.global.appError({
              errorMessage: data.message,
              duration: 4000,
              position: 'top-right',
            });
          } else {
            this.$toasted.show('Success!', {
              type: 'success',
              theme: 'outline',
              position: 'bottom-left',
              fullWidth: true,
              duration: 3300,
            });

            if (data.email_sent) {
              this.$store.commit('updateAuthData', {
                email: this.email,
                name: this.fname,
                status: data.message || undefined,
              });
              // redirect
              this.$router.push({ name: 'verify-account' });
            } else {
              this.$router.push({ name: 'signup-success' });
            }
          }

          return true;
        });

      return true;
    },
  },
  async created() {
    this.$store.dispatch('clearUserSession');
    this.registerAuthStoreModule();

    const [isValidScope, isMainApp, isDevBuild] = await this.$store.dispatch('evaluateScope');

    this.isScopeApp = isValidScope && isMainApp === false && isDevBuild === false;

    await this.$nextTick();
  },
};
